import { render, staticRenderFns } from "./BaseInputFileCard.vue?vue&type=template&id=166f1266&"
import script from "./BaseInputFileCard.vue?vue&type=script&lang=js&"
export * from "./BaseInputFileCard.vue?vue&type=script&lang=js&"
import style0 from "./BaseInputFileCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports